import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import logo from '../../assets/logo/logo.gif'
import Switch from '@material-ui/core/Switch'

import sun from '../../assets/icons/sun.png'
import moon from '../../assets/icons/moon.png'

const DUMMY_LINKS = [
    { content: 'Home', url: '/' },
    { content: 'Installation', url: '/install' }
]

const DUMMY_LINKS_DROPDOWN = [
    {
        content: 'Grid', list: [
            { content: 'Container', url: '/grid/container' },
            { content: 'Column', url: '/grid/column' }
        ]
    }, {
        content: 'Elements', list: [
            { content: 'Background', url: '/elements/bg' },
            { content: 'Button', url: '/elements/button' },
            { content: 'Badge', url: '/elements/badge' },
            { content: 'Card', url: '/elements/card' },
            { content: 'Loader', url: '/elements/loader' },
            { content: 'Table', url: '/elements/table' },
            { content: 'Text', url: '/elements/text' },
            { content: 'Navigation', url: '/elements/nav' },
            { content: 'Modal', url: '/elements/modal' },
            { content: 'Form', url: '/elements/form' },
            { content: 'Spacer', url: '/elements/spacer' },
            { content: 'Gallery', url: '/elements/gallery' },
            { content: 'Alert', url: '/elements/alert' },
            { content: 'List', url: '/elements/list' },
            { content: 'HR', url: '/elements/hr' }
        ]
    },
    {
        content: 'Miscellaneous', list: [
            { content: 'Border', url: '/misc/border' },
            { content: 'Padding', url: '/misc/padding' },
            { content: 'Margin', url: '/misc/margin' },
            { content: 'Flex', url: '/misc/flex' },
            { content: 'Height', url: '/misc/height' },
            { content: 'Rotate', url: '/misc/rotate' },
            { content: 'Rounded', url: '/misc/rounded' },
            { content: 'Shadow', url: '/misc/shadow' },
            { content: 'Overflow', url: '/misc/overflow' },
            { content: 'Image', url: '/misc/image' }
        ]
    },
    {
        content: 'Extra Bits', list: [
            { content: 'Carousel', url: '/components/carousel' },
            { content: 'Calendar', url: '/components/calendar' }
        ]
    }
]

const Nav = () => {

    const [switchState, setSwitchState] = useState({ checked: false });
    const [mobileToggle, setMobileToggle] = useState(false)


    let theme = localStorage.getItem('dark-theme')
    useEffect(() => {
        if (theme === 'true') {
            document.body.className = 'bg-dark'
            setSwitchState({ checked: true })
        } else {
            document.body.classList.remove('bg-dark')
        }
    }, [theme]);

    const mobileNavToggleHandler = () => {
        setMobileToggle(prevState => !prevState)
    }
    const mobileDropdownToggleHandler = (event) => {
        event.target.classList.toggle('expanded')
    }
    const handleChange = (event) => {
        setSwitchState({ [event.target.name]: event.target.checked });
        localStorage.setItem('dark-theme', event.target.checked)
    };


    const navCss = `nav lg secondary px-3 py-1${mobileToggle ? ' mobile-active' : ''}`

    const links = DUMMY_LINKS.map((link, index) => <li key={index}><NavLink exact className='nav-link' to={link.url}>{link.content}</NavLink></li>)
    const dropLinks = DUMMY_LINKS_DROPDOWN.map((link, index) => (
        <li className='dropdown' key={index}>
            <span className='nav-link'>{link.content}</span>
            <ul>{link.list.map((dropdown, index) => <li key={index}><NavLink exact className='nav-link' to={dropdown.url}>{dropdown.content}</NavLink></li>)}</ul>
        </li>
    ))
    const mobileDropLinks = DUMMY_LINKS_DROPDOWN.map((link, index) => (
        <li className='dropdown' key={index} onClick={mobileDropdownToggleHandler} >
            <span className='nav-link'>{link.content}</span>
            <ul>{link.list.map((dropdown, index) => <li key={index}><NavLink exact to={dropdown.url} className='nav-link'>{dropdown.content}</NavLink></li>)}</ul>
        </li>
    ))

    return <nav className={navCss}>
        <div className="brand"> <NavLink to="/" className="brand"><img className='rounded-sm' alt="logo" src={logo} style={{ width: '60px', height: '60px', margin: '3px' }} /></NavLink> </div>
        <div className="menu" onClick={mobileNavToggleHandler}> <div className="hamburger"></div> </div>
        <ul className="nav-list"> {links}</ul>
        <ul className="nav-list right">
            {dropLinks}
            <Switch checked={switchState.checked} onChange={handleChange} name="checked" inputProps={{ 'aria-label': 'secondary checkbox' }} />
            <img style={{
                width: '30px',
                height: '30px'
            }} src={switchState.checked ? moon : sun} alt="theme-indicator" />

        </ul>


        <div className="mobile">
            <div className="header"> <NavLink to="/" className="brand">POKE-CSS</NavLink> </div>
            <ul className="mobile-list">
                {links}
                {mobileDropLinks}
            </ul>
            <div className="footer"> <p className='text warning'>In order to fully experience all parts of this website please use a desktop size screen to view this website.</p> </div>
        </div>

    </nav>
}

export default Nav